import {
  AllInclusiveOutlined as AllAvailableIcon,
  CalendarTodayOutlined as CalendarIcon,
  Inventory2Outlined as InventoryIcon,
  LocationOnOutlined as ZoneIcon,
  SortOutlined as FifoIcon,
  SwapVertOutlined as PriorityIcon,
} from "@mui/icons-material";

export const LOT_STRATEGIES = [
  {
    value: "FIFO",
    label: "FIFO",
    subtitle: "First In, First Out",
    description: "Oldest received lots are allocated first, reducing aging inventory.",
    icon: FifoIcon,
    gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    lightBg: "#f0edff",
    darkBg: "#1e1b3a",
    color: "#667eea",
  },
  {
    value: "FEFO",
    label: "FEFO",
    subtitle: "First Expired, First Out",
    description: "Lots closest to expiry are allocated first. Ideal for perishables.",
    icon: CalendarIcon,
    gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
    lightBg: "#fff0f5",
    darkBg: "#2a1a20",
    color: "#f5576c",
  },
  {
    value: "LIFO",
    label: "LIFO",
    subtitle: "Last In, First Out",
    description: "Most recently received lots are allocated first.",
    icon: InventoryIcon,
    gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
    lightBg: "#e8f7ff",
    darkBg: "#0d1f2d",
    color: "#4facfe",
  },
];

export const WAREHOUSE_STRATEGIES = [
  {
    value: "MAX_INVENTORY",
    label: "Highest Inventory",
    description:
      "Fulfill from the warehouse with the most available stock. Maximises single-warehouse completion.",
    icon: InventoryIcon,
    gradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
    lightBg: "#edfff7",
    darkBg: "#0d2520",
    color: "#38c172",
  },
  {
    value: "ZONE_BASED",
    label: "Zone Based",
    description:
      "Match the customer's pincode to the nearest warehouse using zone charts for faster delivery.",
    icon: ZoneIcon,
    gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
    lightBg: "#fff8e6",
    darkBg: "#2a200d",
    color: "#f6a623",
  },
  {
    value: "PRIORITY",
    label: "Priority Order",
    description:
      "Define a manual warehouse priority. Orders always try warehouses in your specified sequence.",
    icon: PriorityIcon,
    gradient: "linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)",
    lightBg: "#f9f0ff",
    darkBg: "#1e1628",
    color: "#a18cd1",
  },
  {
    value: "ALL_AVAILABLE",
    label: "All Available",
    description:
      "Check all warehouses and split or consolidate based on where stock exists.",
    icon: AllAvailableIcon,
    gradient: "linear-gradient(135deg, #30cfd0 0%, #330867 100%)",
    lightBg: "#e6f9ff",
    darkBg: "#0d1a2a",
    color: "#30cfd0",
  },
];

export const FALLBACK_OPTIONS = [
  { value: "MAX_INVENTORY", label: "Highest Inventory" },
  { value: "FIRST_AVAILABLE", label: "First Available Warehouse" },
  { value: "NONE", label: "Fail — Do Not Auto-Fallback" },
];

export const EMPTY_RULE = {
  name: "",
  description: "",
  is_active: true,
  lot_strategy: "FIFO",
  warehouse_strategy: "MAX_INVENTORY",
  warehouse_priority: [],
  split_order: false,
  fallback_strategy: "FIRST_AVAILABLE",
  client: "",
};
